import cn from 'classnames';
import { Card, FormField, HStack, IconArrowRight, Image, Text } from '@direct-frontend/components';
import { makeModifierClassname } from '@/shared/lib/makeModifierClassname';
import LoyaltyBannerImageSrc from '../../assets/loyaltyBanner.png';
import styles from './LoyaltyBanner.module.css';

interface LoyaltyBannerProps {
    isLoading?: boolean;
    isError?: boolean;
    onClick?: () => void;
}

const modifier = makeModifierClassname(styles, 'card');

export const LoyaltyBanner = (props: LoyaltyBannerProps) => {
    const { isLoading = false, isError = false, onClick } = props;

    return (
        <FormField errorMessage={isError && 'Произошла ошибка при получении скидки'}>
            {() => (
                <Card
                    className={cn(modifier.className, modifier('loading', isLoading))}
                    color="white"
                    borderRadius="20"
                    onClick={onClick}
                >
                    <HStack alignItems="center" justifyContent="space-between">
                        <HStack gap="12" alignItems="center">
                            <Image src={LoyaltyBannerImageSrc} width={68} height={40} alt="Программа лояльности" />

                            <Text className={styles.title} role="main" bold>
                                Получите скидку
                            </Text>
                        </HStack>

                        <Text>
                            <IconArrowRight />
                        </Text>
                    </HStack>
                </Card>
            )}
        </FormField>
    );
};
